import { useEffect } from "react";
import styled from "styled-components";
import Footer from "../../components/footer/Footer";
import Nav from "../../components/navbar/Nav";
import AboutHero from "./components/AboutHero";
import Info from "./components/Info";
import KnowAbout from "./components/KnowAbout";
import LocationMap from "./components/LocationMap";
import Team from "./components/Team";
import Value from "./components/Value";

const About = () => {
   useEffect(() => {
     window.scrollTo(0, 0);
   }, []);
  return (
    <div>
      <StickNavAbout>
        <Nav />
      </StickNavAbout>
      <AboutHero />
      <Info />
      <KnowAbout />
      <Value />
      <Team />
      <LocationMap/>
      <Footer />
    </div>
  );
};

export default About;

export const StickNavAbout = styled.div`
  position: fixed;
  width: 100%;
  transform: translateY(-2rem);
  margin-bottom: 2rem;
  z-index: 10000;
`;
